import {
    updateRoleExperience,
    updateTraining
} from "./actions";

import ItemView from "../../components/ItemView/ItemView.vue"

export default [{
    "path": "/Training",
    "component": { ...ItemView },
    "name": "Training and Experience",
    "meta": {
        "app": "ftc",
        "name": "Training and Experience",
        "sideNav": true,
        "sideNavSection": "Your Details",
        "tableSettings": "Training",
        "hideBackButton": true,
        title() {
            return `Training Information`;
        },
        "menuActions": [{
            "label": "Update Training",
            "action": updateTraining
        }, {
            "label": "Update Role Experience",
            "action": updateRoleExperience
        }],
        "dataFields": [{
            "label": "Crew Resourse Management Training Completion Date",
            compute({ item }) {
                return item?.raw?.CRM?.Completed === "true" ? new Date(item?.raw?.CRM?.Date).toLocaleDateString("en-GB", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                }) : "Not Completed"
            },
            "key": "raw.CRM.Date",
        }, {
            "label": "LFTE Training Completed Date",
            compute({ item }) {
                return item?.raw?.LFTE?.Completed === "true" ? new Date(item?.raw?.LFTE?.Date).toLocaleDateString("en-GB", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                }) : "Not Completed"
            },
            "key": "raw.LFTE.Date",
        }, {
            "label": "Role Experience",
            "key": "raw.RoleExperience",
            "class": "md:col-span-3",
            "richtext": true,
            "grow": true,
        }]
    }
}];
